module.exports = __webpack_public_path__ + "c5504f9b095e2c6422f38687441617b0.png";